/**
 * @file AdminHeader.tsx
 *
 * Top bar for the Online Shop admin. Shows the shop title on the left and the
 * {@link AccountMenu} (account drawer with the language switcher and Log out) on
 * the right. The customer-facing shopfront-language control lives in the Settings
 * tab ({@link SettingsView}).
 */

import { FormattedMessage } from 'react-intl';
import { adminMessages } from '../i18n/messages';
import { AccountMenu } from './AccountMenu';
import styles from './AdminHeader.module.css';

/**
 * The admin top bar (shop title + account menu).
 *
 * @returns The header element.
 */
export function AdminHeader() {
  return (
    <header className={`gv-surface-bright ${styles.header}`} data-testid="admin-header">
      <span className={styles.brand}>
        <FormattedMessage {...adminMessages.shopTitle} />
      </span>
      <AccountMenu />
    </header>
  );
}
